import { useNavigationPermissions } from '../hooks/useNavigationPermissions';
import { useUserCapabilities } from '../hooks/useAuthorization';

/**
 * Navigation configuration and utilities
 */

// Define all navigation items with their permissions
export const navigationItems = [
    // { path: '/dashboard', labelKey: 'navigation.dashboard', icon: 'tachometer-alt' },
    {
        path: '/resources',
        labelKey: 'navigation.resources',
        icon: 'cubes',
        createCapability: 'can_create_personal_resources'
    },
    {
        path: '/categories',
        labelKey: 'navigation.categories',
        icon: 'layer-group',
        createCapability: 'can_manage_resources'
    },
    {
        path: '/locations',
        labelKey: 'navigation.locations',
        icon: 'map-marker-alt',
        createCapability: 'can_manage_locations'
    },
    { path: '/borrowings', labelKey: 'navigation.borrowings', icon: 'exchange-alt' },
    { path: '/profile', labelKey: 'navigation.profile', icon: 'user' }
];

/**
 * Hook to get filtered navigation items based on user permissions
 */
export const useFilteredNavigation = () => {
    const { filterNavItems } = useNavigationPermissions();
    const { capabilities } = useUserCapabilities();

    const enhancedNavigationItems = navigationItems.map(item => {
        const enhancedItem = { ...item };

        // Check if user has create capability for this navigation item
        if (item.createCapability && capabilities?.capabilities) {
            enhancedItem.add_create_button = capabilities.capabilities[item.createCapability] || false;
        } else {
            // No create capability defined or capabilities not loaded, don't show create button
            enhancedItem.add_create_button = false;
        }

        return enhancedItem;
    });

    const filteredNavigationItems = filterNavItems(enhancedNavigationItems);

    return {
        navigationItems: filteredNavigationItems
    };
};

export default useFilteredNavigation;
